/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Writing_ModeInputs */



/**
* | output |
* | --- |
* | "Writing Mode" |
*
* @param {Metadata_Merge_Writing_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_writing_mode = /** @type {((inputs?: Metadata_Merge_Writing_ModeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Writing_ModeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode d'écriture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schreibmodus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità di scrittura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Режим письма")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de escritura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("书写模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書字方向")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लेखन मोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo de escrita")
	return /** @type {LocalizedString} */ ("Writing Mode")
});